var Marionette = require('marionette')
var App = require('app')
// var LeafletSleep = require('leaflet-sleep')

var MapModule = Marionette.Object.extend({
  initialize: function (options) {
    var self = this
    var config = App.config.maps

    this.config = config
    var defaultOptions = {
      'accessToken': config.accessToken,
      'container': 'map',
      'styleToggle': false,
      'zoomLevel': 2,
      'style': config.style,
      'minZoom': config.minZoom,
      'maxZoom': 22,
      'mapOptions': {
        // scrollWheelZoom: false,
        // false if you want an unruly map
        sleep: true,
        // time(ms) until map sleeps on mouseout
        sleepTime: 750,
        // time(ms) until map wakes on mouseover
        wakeTime: 750,
        // should the user receive wake instrurctions?
        sleepNote: false,
        // should hovering wake the map? (non-touch devices only)
        hoverToWake: false,
        // a message to inform users about waking the map
        wakeMessage: 'Click or Hover to Wake',
        // a constructor for a control button
        // sleepButton: L.Control.sleepMapControl,
        // opacity for the sleeping map
        sleepOpacity: 1
      }

    }

    options = _.extend(defaultOptions, options)

    this.options = options
    this.popupVisible = false;    
    this.mapElement = document.querySelector('#' + options.container)

    //
    L.mapbox.accessToken = options.accessToken
    this.map = L.mapbox.map(options.container, false, options.mapOptions).setView(options.location, options.zoomLevel)
    this.markers = {}


  //  this.streetStyle = L.mapbox.styleLayer(options.style).addTo(this.map)

    // style
    // L.mapbox.styleLayer(
    //   options.style,
    //   {
    //     'minZoom': options.minZoom,
    //     'maxZoom': options.maxZoom
    //   }
    // ).addTo(this.map)

    this.geojson = L.geoJson([], {
      pointToLayer: function (feature, latlng) {
        return L.marker(latlng, {
          icon: L.divIcon({
            className: 'css-icon',
            iconSize: [30, 30],
            html: self.generateDriverMarker(feature),
            popupAnchor: [0, -10]
          })
        })
      },
      onEachFeature: function (feature, layer) {
        var stateClasses = ''
        if (feature.properties.online) {
          stateClasses += ' is-online'
        } else {
          stateClasses += ' is-offline'
        }

        if (feature.properties.error) {
          stateClasses += ' is-error'
        }

        var popupBody = '<div class="js-marker-popup-container" data-marker-id="' + feature.properties.id + '"> \
          <div class="popup__header">' + feature.properties.name + '</div> \
          <div class="popup__footer"> \
            <div class="popup__info"> \
              <div class="device-status ' + stateClasses + '"></div> \
            </div> \
            <div class="popup__controls"> \
              <span class="m-icon-btn icon-control js-control" data-device-id="' + feature.properties.id + '"></span> \
              <span href="#" class="m-icon-btn icon-edit js-edit" data-device-id="' + feature.properties.id + '"></span> \
              <span class="m-icon-btn icon-show js-show" data-device-id="' + feature.properties.id + '"></span> \
            </div> \
          </div> \
        </div>'
        // if (feature.properties.color) {
        //   popupText += '<br/>color: ' + feature.properties.color
        // }
        layer.bindPopup(popupBody, {
          className: 'm-marker-popup'
        })
      }
    })

    //
    this.initClusters()

    //
    this.map.on('popupopen', function (e) {
      var popup = e.popup._wrapper
      popup.querySelector('.js-edit').addEventListener('click', self.onPopupEditClick)
      popup.querySelector('.js-control').addEventListener('click', self.onPopupControlClick)
      popup.querySelector('.js-show').addEventListener('click', self.onPopupShowClick)
      self.popupVisible = true;
    })
    this.map.on('popupclose', function (e) {
      var popup = e.popup._wrapper
      popup.querySelector('.js-edit').removeEventListener('click', self.onPopupEditClick)
      popup.querySelector('.js-control').removeEventListener('click', self.onPopupControlClick)
      popup.querySelector('.js-show').removeEventListener('click', self.onPopupShowClick)
      self.popupVisible = false;
      
    })

    if (options.styleToggle) {
      this.renderStyleToggle()
    }

    setTimeout(function () {
      self.showStreetStyle()
    }, 0)
  // var markers = L.markerClusterGroup()
  // markers.addLayer(L.marker(getRandomLatLng(map)))
  // ... Add more layers ...
  // map.addLayer(markers)
  },
  initClusters: function () {

    var self = this
    this.clusters = L.markerClusterGroup({
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      removeOutsideVisibleBounds: true,
      zoomToBoundsOnClick: true,
      iconCreateFunction: function (cluster) {
        var markers = cluster.getAllChildMarkers()
        var len = markers.length
        var error = false

        while (len--) {
          // if a marker has an error, propagate this to the cluster
          if (markers[len].feature.properties.error) {
            error = true
            break
          }
        }

        var html = ''
        if (error) {
          html = "<div class='m-cluster has-error'></div>"
        } else {
          html = "<div class='m-cluster'><span class='m-cluster__number'>" + cluster.getChildCount() + '</span></div>'
        }
        // console.log(markers)
        return new L.DivIcon({ className: 'cluster', iconSize: [40, 40], html: html })
      }

    })

    this.map.addLayer(this.clusters)
  },
  removeClusters: function () {
    this.map.removeLayer(this.clusters)
  },
  /**
   * Style toggle
   */
  toggleStyle: function () {
    if (this.currentStyle === 'street') {
      this.showSatelliteStyle()
    } else {
      this.showStreetStyle()
    }
  },
  renderStyleToggle: function () {
    var styleToggle = document.createElement('div')
    styleToggle.innerHTML = 'Satellite'
    styleToggle.className = 'map-style-toggle'
    this.styleToggle = styleToggle
    this.mapElement.appendChild(styleToggle)

    styleToggle.addEventListener('click', _.bind(this.toggleStyle, this))
  },
  changeStyleToggleLabel: function (label) {
    if (!this.options.styleToggle) return false

    this.styleToggle.innerHTML = label
  },
  showSatelliteStyle: function () {
    //    this.removeClusters()
    
        this.currentStyle = 'satellite'
        this.changeStyleToggleLabel('Street')
    
        if (this.streetStyle) this.map.removeLayer(this.streetStyle)
    
        this.setMaxZoom(18)
        this.satelliteStyle = L.mapbox.styleLayer(this.config.satelliteStyle).addTo(this.map)
        //this.initClusters()
      },
      showStreetStyle: function () {
        this.currentStyle = 'street'
        this.changeStyleToggleLabel('Satellite')
        //
        if (this.satelliteStyle) this.map.removeLayer(this.satelliteStyle)
        this.streetStyle = L.mapbox.styleLayer(this.config.style,
          {
            'minZoom': this.options.minZoom,
            'maxZoom': 21
    
          }).addTo(this.map)
        this.setMaxZoom(21)
        //this.initClusters()
      },
  setMaxZoom: function (level) {
  //  this.removeClusters()
    var curZoomLevel = this.map.getZoom()

    if (curZoomLevel > level) {
      this.map.setZoom(level)
    }
    this.map.options.maxZoom = level
    this.map.fire('zoomend')
    // this.initClusters()
  },

  onPopupEditClick: function (e) {
    var deviceId = e.target.getAttribute('data-device-id')
    App.globalChannel.trigger('map:device:edit', {deviceId: deviceId})
  },
  onPopupControlClick: function (e) {
    var deviceId = e.target.getAttribute('data-device-id')
    App.globalChannel.trigger('map:device:control', {deviceId: deviceId})
  },
  onPopupShowClick: function (e) {
    var deviceId = e.target.getAttribute('data-device-id')
    App.globalChannel.trigger('map:device:show', {deviceId: deviceId})
  },
  generateDriverMarker: function (feature) {
    //console.log('generate driver')
    var classNames = ''

    if (feature.properties.error) {
      classNames += ' has-error'
    }
    classNames += ' '+Math.random();

    // parking_detect, determine the status and add classes to the marker
    if (feature.properties.type == 'parking_node') {
      let value = 0;
      // if there is a model available 
      if (_.has(feature, 'properties.model')) {
        value = _.get(feature, 'properties.model.attributes.sensors.parking_detect.value');
      } else {
        if (feature.sensors.parking_detect) value = feature.sensors.parking_detect      
      }
      classNames += (value) ? ' is-positive' : ' is-negative';
    }


    function generateRandomColourField () {
      return Math.round(Math.random() * 255)
    }
    function generateRandomColour () {
      return {r: generateRandomColourField(), g: generateRandomColourField(), b: generateRandomColourField()}
    }

    var color1 = generateRandomColour()
    var color2 = generateRandomColour()

    var html = ''
    switch (feature.properties.type) {
      case 'rgb_driver':
        html = '<div class="m-marker ' + feature.properties.type + ' ' + classNames + '"><div class="m-marker__inner"><div class="m-marker__color"><div class="color__ring color__ring-one"></div><div class="color__ring color__ring-two"></div></div><div class="m-marker__icon"></div></div></div>'
        break
      case 'parking_node':
        html = '<div class="m-marker ' + feature.properties.type + ' ' + classNames + '"><div class="m-marker__inner"><div class="m-marker__icon"></div></div></div>'      
        break
      case 'ird_driver':
      case 'rtm_rc':
        html = '<div class="m-marker ' + feature.properties.type + ' ' + classNames + '"><div class="m-marker__backdrop"></div><div class="m-marker__inner"><div class="m-marker__icon"></div></div></div>'
        break
      default:
        html = '<div class="m-marker ' + feature.properties.type + ' ' + classNames + '"><div class="m-marker__inner"><div class="m-marker__icon"></div></div></div>'
        break
    }
    // var html = '<div class="m-marker ' + feature.properties.type + '"><div class="m-marker__icon"></div></div>'

    // var html = '<div class="m-marker"><div class="color_ring color_ring_one" style="background-color: rgb(' + color1.r + ',' + color1.g + ',' + color1.b + ');"></div><div class="color_ring color_ring_two" style="background-color: rgb(' + color2.r + ',' + color2.g + ',' + color2.b + ');"></div><div class="inner"></div></div>'
    return html
  },
  setGeoJson: function (geojsonD) {
    
    if (this.popupVisible) return

    // remove the existing layers
    this.clusters.removeLayer(this.geojson)
    this.map.removeLayer(this.clusters)
    this.geojson.clearLayers() // inherited from LayerGroup
    
    // add the new geo data
    this.geojson.addData(geojsonD)
    this.clusters.clearLayers()
    this.clusters.addLayer(this.geojson)
    this.map.addLayer(this.clusters)
    

  },
  zoomToFitAll: function () {

    if (!this.clusters) return;
    
    // determine if there are items in the cluster
    let layers = this.clusters.getLayers();
    if (!layers.length) return;

    // position map
    var bounds = this.clusters.getBounds()
    this.map.fitBounds(bounds)    

  },
  setPosition: function (location) {
    this.map.setView(location, 16)
  },
  addClusterMarkers: function () {},
  setMarkerPosition: function (markerId, position) {
    var marker = this.markers[markerId]
    if (!marker) return false
    marker.setLatLng(position)
  },
  addMarker: function (location, options) {
    var self = this

    if (options.feature) {
      var markerOptions = {
        draggable: false,
        icon: L.divIcon({
          className: 'css-icon',
          iconSize: [30, 30],
          html: self.generateDriverMarker(options.feature),
          popupAnchor: [0, -10]
        })
      }
    } else {
      var markerOptions = {
        draggable: false,
        icon: L.mapbox.marker.icon(
          { 'marker-color': '#f86767' }
        )
      }
    }

    if (options.mapBoxOptions) {
      _.extend(markerOptions, options.mapBoxOptions)
    }

    var marker = L.marker(location, markerOptions)

    if (options.onDragEnd) {
      marker.on('dragend', options.onDragEnd)
    }

    marker.addTo(this.map)

    if (options.id) {
      this.markers[options.id] = marker
    }

    // initalize the map
    // var map = L.mapbox.map('map').setView(loc, 22)
    // var styleLayer = L.mapbox.styleLayer(
    //   'mapbox://styles/jeroenbraspenning/cit716whb000e2xp0nk1lzlb4',
    //   {
    //     'minZoom': 0,
    //     'maxZoom': 21
    //   }
    // ).addTo(map)

  // place the marker
  /* var marker = L.marker(
     loc,
     {
       icon: L.mapbox.marker.icon(
         { 'marker-color': '#f86767' }
       ),
       draggable: true
     }
   ) */
  }
})

module.exports = MapModule



// WEBPACK FOOTER //
// ./js/common/map.js